/**
 * Decorative two-hue gradient pairs for generated testimonial avatars. Each pair
 * is *analogous* (its two colors sit near each other on the wheel) so the blend
 * stays clean and vivid, and the set deliberately spans teals, greens, blues,
 * and warm coral/amber so the avatar wall reads colorful.
 *
 * These are arbitrary DECORATIVE hues, not design-system theme colors — so this
 * module is the one sanctioned home for the avatar palette and is exempt from
 * the token + brand gates (same pattern as src/config/brand.default.ts). Keeping
 * them here lets the palette stay exactly as designed instead of being flattened
 * through the 3-color brand scale.
 */
export const AVATAR_RAMPS: ReadonlyArray<readonly [string, string]> = [
  ["#0FA08C", "#3B82F6"], // teal → blue
  ["#FF7A59", "#FFB020"], // coral → gold
  ["#1E9E5A", "#2BD4B5"], // green → mint
  ["#3B82F6", "#22C1C3"], // blue → cyan
  ["#F2704A", "#E8578A"], // coral → rose
  ["#12B886", "#0FA08C"], // green → teal
  ["#EDA100", "#FF7A59"], // amber → coral
  ["#0EA5A0", "#2BD4B5"], // deep teal → mint
];
